// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.GridPreviewPopupMetric.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import DropDown from 'share/components/controls/Izenda.DropDown';
import ReportPartToolbar from './Izenda.ReporPartToolbar';
import { map } from 'lodash/fp';
import PropTypes from 'prop-types';

const GridPreviewPopupMetric = ({ localization, gridReportParts, onChange, selectedPart }) => {
  const options = map('metric', gridReportParts);

  return (
    <ReportPartToolbar>
      <div className="u-posTopRight u-posAbsolute u_textRight">
        <span className="u_paddingLeftRight">{localization.getText('REPORTDESIGNER_LABEL_METRICS')}</span>
        <DropDown
          onChange={onChange}
          options={options}
          value={selectedPart.metric.value}
          labelField="label"
          valueField="value"
        />
      </div>
    </ReportPartToolbar>
  );
};

GridPreviewPopupMetric.propTypes = {
  gridReportParts: PropTypes.object,
  onChange: PropTypes.func,
  selectedPart: PropTypes.object
};

export default connect()(GridPreviewPopupMetric);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/Izenda.GridPreviewPopupMetric.js